import { gql } from '@apollo/client';

/**
 * Spec 0010 — per-lesson Excalidraw whiteboard, ERP read-only viewer.
 *
 * Heavy query for `/whiteboard/lesson/:id`: brings the full serialized
 * scene (`sceneJson` is the raw `serializeAsJSON` payload — the client
 * JSON.parses it) plus the refs of every lesson the board is linked to.
 *
 * `files` (rev.3): board images now live on the private S3 bucket instead
 * of inline base64 in the scene, so a saved scene keeps only `fileId`
 * refs on its image elements. Each entry's `url` is a short-TTL presigned
 * GET link the viewer fetches and hands to excalidraw via `addFiles`.
 * Without it images render as blank placeholders.
 *
 * Operation name intentionally differs from the backend field
 * (`lessonWhiteboardForErp`) — see the graphql-codegen skill note on
 * result-type collapse.
 */
export const LessonWhiteboardErpQueryDocument = gql`
  query GetLessonWhiteboardErp($lessonId: ID!) {
    lessonWhiteboardForErp(lessonId: $lessonId) {
      id
      name
      sceneJson
      sceneVersion
      updatedAt
      files {
        fileId
        mimeType
        url
      }
      lessons {
        lessonId
        lessonName
        lessonNumber
        lessonDate
      }
    }
  }
`;

/**
 * Light header query for the whiteboard page: lesson name/date/time and
 * the owning group (name + id for the «back to group card» link). Reuses
 * the ERP `zoomLesson` field — its access list (ADMIN / ACCOUNT_MANAGER /
 * METHODIST) matches `lessonWhiteboardForErp` exactly.
 */
export const WhiteboardLessonHeaderQueryDocument = gql`
  query LessonHeaderForWhiteboard($groupLessonId: ID!) {
    zoomLesson(groupLessonId: $groupLessonId) {
      id
      name
      date
      startTime
      endTime
      lessonNumber
      whiteboardId
      module {
        id
        group {
          id
          name
        }
      }
    }
  }
`;
